/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-11-02 13:05:01
 */
export default {
  '序号': '序号',
  '含扩容：': '含扩容：',
  'EPOS授权信息': 'EPOS授权信息',
  '汇总：': '汇总：',
  '剩余': '剩余',
  '绑定类型：': '绑定类型：',
  '剩余天数': '剩余天数',
  '操作': '操作',
  '查看': '查看',
  '店务': '店务',
  '店铺授权容量': '店铺授权容量',
  'WEB授权容量': 'WEB授权容量',
  '移动授权容量': '移动授权容量',
  '合同编号': '合同编号',
  '开始/结束时间': '开始/结束时间',
  'Android平板': 'Android平板',
  'Android手机': 'Android手机',
  'IPhone': 'IPhone',
  'IPAD': 'IPAD',
  'WEB': 'WEB',
  '授权信息': '授权信息',
  '查看变更记录': '查看变更记录',
  '店铺授权清单': '店铺授权清单',
  '设备归属清单': '设备归属清单',
  '新增授权店铺': '新增授权店铺',
  '管理': '管理',
  '数量': '数量',
  '已过期': '已过期',
  '未生效': '未生效',
  '不足一天': '不足一天',
  '管理所有店铺授权': '管理所有店铺授权',
  '管理所有归属设备': '管理所有归属设备',
  '关闭': '关闭',
  '授权全部渠道': '授权全部渠道',
  '确认授权所有店铺？': '确认授权所有店铺？',
  '操作日期': '操作日期',
  '类型': '类型',
  '操作内容': '操作内容',
  '操作人': '操作人',
  '店铺编号': '店铺编号',
  '店铺简称': '店铺简称',
  '店铺全称': '店铺全称',
  'WEB设备': 'WEB设备',
  '移动': '移动',
  '机器编号': '机器编号',
  '机器码': '机器码',
  '设备类型': '设备类型',
  '绑定类型': '绑定类型',
  '绑定日期': '绑定日期',
  '状态': '状态',
  '余量：': '余量：',
  '（含扩容：': '（含扩容：',
  '该店铺不存在或已授权': '该店铺不存在或已授权',
  '请输入': '请输入',
  '授权设备类型': '授权设备类型',
  '绑定状态': '绑定状态',
  '请选择': '请选择',
  '筛选': '筛选',
  '清空': '清空',
  '返回': '返回',
  '设备绑定列表': '设备绑定列表',
  '解除授权': '解除授权',
  '移出黑名单': '移出黑名单',
  '加入黑名单': '加入黑名单',
  '全选': '全选',
  '提示': '提示',
  '取消': '取消',
  '确定': '确定',
  '正常': '正常',
  '白名单': '白名单',
  '黑名单': '黑名单',
  '激活码': '激活码',
  '安卓手机': '安卓手机',
  '安卓平板': '安卓平板',
  '禁用': '禁用',
  '启用': '启用',
  'EPOS版本': 'EPOS版本',
  '企业': '企业',
  '企业编号': '企业编号',
  '设备机型': '设备机型',
  '系统版本号': '系统版本号',
  'EPOS版本号': 'EPOS版本号',
  '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作': '解除往期的激活码/店铺容量绑定，避免影响店铺pos数量超出限额，确认提示框提醒是否继续操作',
  '允许登陆pos': '允许登陆pos',
  '释放往期的激活码/店铺容量': '释放往期的激活码/店铺容量',
  '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作': '限制登陆pos，需解除绑定激活码、解除店铺归属，是否继续操作',
  '是否解除绑定': '是否解除绑定',
  '解除绑定': '解除绑定',
  '是否': '是否',
  '解绑成功': '解绑成功',
  '店铺授权': '店铺授权',
  '新增店铺授权': '新增店铺授权',
  '总量': '总量',
  '授权日期': '授权日期',
  '合同编号：': '合同编号：',
  '请输入合同编号': '请输入合同编号',
  '店铺编号：': '店铺编号：',
  '请输入店铺编号': '请输入店铺编号',
  '店铺授权列表': '店铺授权列表',
  'WEB限额': 'WEB限额',
  'WEB限额余量': 'WEB限额余量',
  '移动限额': '移动限额',
  '移动限额余量': '移动限额余量',
  '扩容': '扩容',
  '移动扩容:': '移动扩容',
  'WEB扩容:': 'WEB扩容',
  '扩容成功': '扩容成功',
  '将影响已授权的店铺登录，是否确定调整': '将影响已授权的店铺登录，是否确定调整',
  '登录记录查看': '登录记录查看',
  '请输入收银员名称': '请输入收银员名称',
  '请输入机器编号': '请输入机器编号',
  '请输入版本号': '请输入版本号',
  '至': '至',
  '开始日期': '开始日期',
  '结束日期': '结束日期',
  '搜索': '搜索',
  '登录时间': '登录时间',
  '收银员': '收银员',
  '门店': '门店',
  '设备型号': '设备型号',
  '系统版本': '系统版本',
  '经纬度': '经纬度',
  '定位地址': '定位地址',
  '最近一周': '最近一周',
  '最近一个月': '最近一个月',
  '最近三个月': '最近三个月',
  'Iphone': 'Iphone',
  'Ipad': 'Ipad',
  'WEB已用': 'WEB已用',
  '移动已用': '移动已用',
  '调整限额': '调整限额',
  '收银': '收银',
  '物流': '物流',
  '公告': '公告',
  '储位': '储位',
  '其他': '其他',
  '授权模块': '授权模块',
  '清理闲置设备': '清理闲置设备',
  '最近登录日期': '最近登录日期',
  '未登录天数': '未登录天数',
  '机器编码': '机器编码',
  '未登录天数大于': '未登录天数大于',
  '请输入店铺简称': '请输入店铺简称',
  '解除全部': '解除全部',
  '请输入或选择': '请输入或选择',
  '解绑全部': '解绑全部',
  '将批量解绑所有设备，是否确认操作': '将批量解绑所有设备，是否确认操作',
  // 4.2
  '设备变更记录': '设备变更记录',
  '操作时间': '操作时间',
  '收营员编号': '收营员编号',
  '操作状态': '操作状态',
  '请输入收银员账号': '请输入收银员账号',
  '设备解绑记录': '设备解绑记录',
  '收银员帐号': '收银员帐号',
  '合同变更记录': '合同变更记录',
  '不限': '不限',
  '设备归属列表': '设备归属列表',
  '创建合同': '创建合同',
  '合同初始化': '合同初始化',
  '更新设备授权': '更新设备授权',
  '更新店铺数量': '更新店铺数量',
  '续约': '续约',
  '模块配置': '模块配置',
  '更新Webpos数量': '更新Webpos数量',
  '移动POS数量': '移动POS数量',
  '授权店铺数量': '授权店铺数量',
  '更新合同服务日期': '更新合同服务日期',
  '店铺': '店铺',
  'Webpos最高限额': 'Webpos最高限额',
  '请输入限额': '请输入限额',
  '移动POS限额': '移动POS限额',
  '请输入本期授权的店铺总量': '请输入本期授权的店铺总量',
  '请输入本期授权的数量': '请输入本期授权的数量',
  '授权的数量必须为正整数': '授权的数量必须为正整数',
  'Webpos最高限额不能低于': 'Webpos最高限额不能低于',
  '不能低于': '不能低于',
  '归属店铺': '归属店铺',
  '全部': '全部',
  '取消归属': '取消归属',
  'Webpos限额': 'Webpos限额',
  '合同类型': '合同类型',
  '租用': '租用',
  '购买': '购买',
  '导出': '导出',
  '文件大小不能超过1M！': '文件大小不能超过1M！',
  '设备在线监管': '设备在线监管',
  '设备状态': '设备状态',
  '强制下线': '强制下线',
  '在线': '在线',
  '离线': '离线',
  '收银员编号': '收银员编号',
  '收银员名称': '收银员名称',
  '上线时间': '上线时间',
  '下线时间': '下线时间',
  '上/下线时间': '上/下线时间',
  '操作成功': '操作成功',
  '机器号': '机器号',
  '查询': '查询',
  'Android': 'Android'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/contract.js